import { useEffect, useState, useCallback } from "react";

const useRequestQueue = (maxConcurrent) => {
  const [queue, setQueue] = useState([]); // bekleyen isteklerin kuyruğu
  const [pendingRequests, setPendingRequests] = useState([]); // şu anda işlenmekte olan istekler

  const enqueue = useCallback(
    async (requestFunc) => {
      // Yeni bir isteği kuyruğa ekler ve gerekiyorsa işlemeye başlar
      return new Promise((resolve, reject) => {
        const queuedRequest = () => requestFunc().then(resolve).catch(reject);
        setQueue((prevQueue) => [...prevQueue, queuedRequest]);
      });
    },
    [setQueue]
  );

  const dequeue = useCallback(() => {
    setQueue((currentQueue) => {
      const nextRequest = currentQueue[0];
      if (pendingRequests.length < maxConcurrent && nextRequest) {
        setPendingRequests((currentPending) => [
          ...currentPending,
          nextRequest,
        ]);
        return currentQueue.slice(1);
      }
      return currentQueue;
    });
  }, [pendingRequests.length, maxConcurrent, setPendingRequests, setQueue]);

  // Kuyruğu işlemek için
  useEffect(() => {
    if (pendingRequests.length < maxConcurrent && queue.length > 0) {
      // Kuyrukta işlenmeyi bekleyen istekler varsa
      const nextRequest = queue.shift(); // Kuyruktan bir isteği al
      nextRequest().finally(() => {
        // İstek tamamlandığında veya hata verdiğinde:
        setPendingRequests((currentPending) => currentPending.slice(1)); // bu isteği işlenmekte olanlar listesinden çıkar
      });
      setPendingRequests((currentPending) => [...currentPending, nextRequest]); // ve işlenmekte olanlara ekle
    }
  }, [pendingRequests, maxConcurrent, queue]);

  // Enqueue ve dequeue fonksiyonlarını döndür
  return { enqueue, dequeue };
};

export default useRequestQueue;
